import { render } from "./BotOnielCari.vue?vue&type=template&id=6954e1b6&scoped=true"
import script from "./BotOnielCari.vue?vue&type=script&lang=js"
export * from "./BotOnielCari.vue?vue&type=script&lang=js"

import "./BotOnielCari.vue?vue&type=style&index=0&id=6954e1b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6954e1b6"]])

export default __exports__